import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import {
  setUploadMsg,
  uploadEmployeesClear,
  uploadEmployeesInitiate,
} from '../../../../actions/employee';
import { openErrorToast } from '../../../../reducers/uiLogic';
import { employeeUploadMsg } from '../../../common/components/constants';
import UploadEmployees from './UploadEmployees';

const mapStateToProps = state => {
  return {
    uploadMsg: _get(state, 'employees.uploadMsg', employeeUploadMsg),
    fileUploading:
      _get(state, 'apiState.UPLOAD_EMPLOYEES.isFetching', false) &&
      !_get(state, 'apiState.UPLOAD_EMPLOYEES.isIdle', false),
    fileUploaded: _get(state, 'apiState.UPLOAD_EMPLOYEES.success', false),
    processId: _get(state, 'employees.processId', ''),
  };
};

const mapDispatchToProps = dispatch => ({
  clearUpload: () => dispatch(uploadEmployeesClear()),
  uploadEmployees: payload => dispatch(uploadEmployeesInitiate(payload)),
  setFileUploadMsg: message => dispatch(setUploadMsg(message)),
  showErrorToast: message => dispatch(openErrorToast(message)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UploadEmployees);
